export default __webpack_public_path__ + "static/logo-mini-bf597b31c044e7861fd0bd912611348e.svg";